/*!
 * Generated with Blocksfabrik.
 */
import { r as registerInstance, h, H as Host } from './index-4b76581b.js';

const CustomRender = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.wrapAs = 'div';
  }
  render() {
    return (h(Host, null, this.wrapAs === 'div' ? (h("div", { class: 'ha-' + this.wrapperClassName, innerHTML: this.customContent })) : (h("span", { class: 'ha-' + this.wrapperClassName, innerHTML: this.customContent }))));
  }
};

export { CustomRender as ha_custom_render };
